
export class ComentariosDTO {
    comentario: string;

    constructor() {

    }
}